var cbs = [], 
	data;
module.exports = function(cb) {
	if(cbs) cbs.push(cb);
	else cb(data);
}
require.ensure([], function(require) {
	data = require("!!./swiper.js");
	var callbacks = cbs;
	cbs = null;
	for(var i = 0, l = callbacks.length; i < l; i++) {
		callbacks[i](data);
	}
}, "slider");


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?name=slider!./~/Swiper/dist/js/swiper.js
// module id = 41
// module chunks = 6 8